import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import qs from 'query-string';
import { navigateTo, PageComponentId } from '@wix/business-manager-api';

export default class NavigationStore extends RouterStore {
  history;

  navigationTemplate = {
    pageComponentId: PageComponentId.AppMarket,
    contextData: { referrer: 'promote-marketing-integration' },
  };

  constructor({ config }) {
    super();
    this.history = syncHistoryWithStore(config.browserHistory, this);
  }

  get path() {
    return this.history.location.pathname;
  }

  get query() {
    return qs.parse(this.history.location.search);
  }

  openUpgradeModal = () => this.push(this.path + '/upgrade');

  openDialogErrorModal = () => {
    const newUrl = this.path.replace('dialog', 'error');
    this.replace(newUrl);
  };

  openWidget = (type) => this.push(`/widget/${type}`);

  openWidgetModal = (type) => this.push(`/widget/${type}/dialog`);

  navigateToAppMarket = (uri) => {
    if (window.ModuleRegistry) {
      window.ModuleRegistry.invoke('businessManager.navigateTo', {
        ...this.navigationTemplate,
        ...{
          contextData: { appState: uri, referrer: 'marketing-integrations' },
        },
      });
    }
  };

  navigateToCookiesSettings = () => {
    navigateTo({
      pageComponentId: PageComponentId.CookieConsentBannerSettings,
      contextData: { referrer: 'marketing-integrations' },
    });
  };
}
